const API_URL = '/api/projects';

export const getProjects = async () => {
    const response = await fetch(API_URL);
    if (!response.ok) {
        throw new Error('Failed to fetch projects');
    }
    return response.json();
};

export const createProject = async (formData) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        body: formData,
    });
    if (!response.ok) {
        throw new Error('Failed to create project');
    }
    return response.json();
};

export const deleteProject = async (id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
    });
    if (!response.ok) {
        throw new Error('Failed to delete project');
    }
};
